import { useState, useEffect } from "react";
import { formatHora } from "../utils/dateUtils";
import { Typography } from "@mui/material";

export default function Clock() {
    const [horaAtual, setHoraAtual] = useState('');

    useEffect(() => {
        const update = () => {
        setHoraAtual(formatHora(new Date()));
        };

        update();

        const interval = setInterval(update, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Typography variant='h4' fontFamily='monospace'>{horaAtual}</Typography>
    );
}